import { TreePine, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UserProfile } from '@/components/auth';
import { Navigation } from './sidebar/Navigation';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  isAdmin: boolean;
  isMobile: boolean;
}

export function Sidebar({ isOpen, onClose, isAdmin, isMobile }: SidebarProps) {
  return (
    <>
      {/* Mobile backdrop */}
      {isMobile && (
        <div
          className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 ${
            isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
          onClick={onClose}
        />
      )}

      {/* Sidebar content */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white shadow-xl flex flex-col z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } ${!isMobile ? '!transform-none' : ''}`}
      >
        {/* Mobile header */}
        {isMobile && (
          <div className="flex items-center justify-between px-4 py-3 border-b">
            <div className="flex items-center">
              <TreePine className="h-8 w-8 text-primary" />
              <span className="mr-2 text-xl font-semibold text-primary-dark">
                الخدمات الإلكترونية
              </span>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="text-gray-500 hover:bg-gray-100"
            >
              <X className="h-6 w-6" />
            </Button>
          </div>
        )}

        {/* Navigation */}
        <Navigation isAdmin={isAdmin} onClose={onClose} />

        {/* User Profile */}
        <div className="border-t p-4">
          <UserProfile />
        </div>
      </div>
    </>
  );
}